/*
    Видео с ютуба на странице
*/

let $videoWrap = $('.js-video-item-wrap');
//let imgTemplate = '//img.youtube.com/vi/#/sddefault.jpg';
let imgTemplate = '//img.youtube.com/vi/#/maxresdefault.jpg';

if ($videoWrap.length) {
    $videoWrap.each((index, el) => {
        let $self = $(el);
        let currFrame = $self.find('iframe');
        let currFrameUrl = currFrame.attr('src');
        let _previewPics = currFrameUrl.split('/');
        let previewPicUrl;

        currFrame.wrap('<div class="video-wrap" />');
        let $videoWrap = $self.find('.video-wrap');

        if ($self.data('preview')) {
            previewPicUrl = $self.data('preview');
        } else {
            previewPicUrl = _previewPics[_previewPics.length - 1];
            previewPicUrl = imgTemplate.replace('#', previewPicUrl.split('?')[0]);
        }

        $videoWrap.append(`<div class="video-wrap__play js-video-item-wrap-play" style="background-image: url('${previewPicUrl}')"></div>`);

        let template = currFrame[0].outerHTML;

        currFrame.remove();

        $videoWrap.find('.js-video-item-wrap-play').on('click', (e) => {
            e.preventDefault();
            $self.addClass('_play');

            let urlConnector = currFrameUrl.indexOf('?') > 0 ? '&' : '?';

            template = template.replace(/data-gtm-yt-inspected-[^"]*="[^"]*"/, ''); // удаляем для корректной аналитики
            template = template.replace(/ id="[^"]*"/, ''); // удаляем для корректной аналитики
            template = template.replace(/src="[^"]*"/, `src="${currFrameUrl + urlConnector}autoplay=1"`);
            template = template.replace(/allow="/, `allow="autoplay; `);

            $videoWrap.prepend(template);
        });
    });
}

export function getYoutubePreview(currFrameUrl) {
    let _previewPics = currFrameUrl.split('/');
    let previewPicUrl;

    previewPicUrl = _previewPics[_previewPics.length - 1];
    return imgTemplate.replace('#', previewPicUrl.split('?')[0]);
}

let $videoBlock = $('.video-block-wrapper');

if ($videoBlock.length) {
    function loadPlayer() {
        if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
            let tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";

            let firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubePlayerAPIReady = function () {
                onYouTubePlayer();
            };
        } else {
            window.onYouTubePlayerAPIReady = function () {
                onYouTubePlayer();
            };
        }
    }

    function onYouTubePlayer() {
        $videoBlock.each((index, el) => {
            let $self = $(el);
            let currFrame = $self.find('iframe');
            let player;
            let width = currFrame.width();
            let height = currFrame.height();
            currFrame.attr('id', `video-block-player-${index}`);
            const id = currFrame.attr('id');
            let src = currFrame.attr("src");
            //splitting to get the videoId from src.
            let partsArr = src.split("/");
            let videoSource = partsArr[partsArr.length -1 ].split("?");
            let videoId = videoSource[videoSource.length -2 ];
            let metrics = currFrame.attr('data-ya-metrics');

            function onYouTubeIframeAPIReady() {
                player = new YT.Player(id, {
                    height: height,
                    width: width,
                    videoId: videoId,
                    events: {
                        'onStateChange': function(event) {
                            if (event.data == YT.PlayerState.PLAYING) {
                                if (metrics) startVideo(metrics);
                            }
                        }
                    }
                });
            }
            function startVideo(metrics) {
                const args = metrics.split(',');
                ym.apply(null, args);
            }

            onYouTubeIframeAPIReady(metrics);
        });
    }

    loadPlayer();
}
